export default {
  additional_data: (state) => {
    return state.additional_data;
  },
}
